import React from 'react'
import { Alert, AlertTitle } from '@mui/material'

export const CARE_COORDINATION_SUPPORT_EMAIL = 'support@meruhealth.com'

/**
 * Shown on saved financial eligibility entries so therapists don't present the
 * cost estimate to patients as their final cost. Plain text only: therapists relay
 * these instructions to the patient, so there is nothing for them to click.
 */
const CostEstimateDisclaimer = () => (
  <Alert severity="warning" sx={{ my: 2 }}>
    <AlertTitle>These amounts are estimates — not the final cost</AlertTitle>
    Never present them to the patient as final. The actual cost is set once the insurance claim is processed.
    <br />
    If the patient asks about their actual cost, direct them to Care Coordination in the Meru app:{' '}
    <strong>Menu (top right corner) → Get support</strong>, or <strong>{CARE_COORDINATION_SUPPORT_EMAIL}</strong>.
  </Alert>
)

export default CostEstimateDisclaimer
